import { render, staticRenderFns } from "./InnerCard.vue?vue&type=template&id=1fbb9b3b&scoped=true&"
import script from "./InnerCard.vue?vue&type=script&lang=js&"
export * from "./InnerCard.vue?vue&type=script&lang=js&"
import style0 from "./InnerCard.vue?vue&type=style&index=0&id=1fbb9b3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb9b3b",
  null
  
)

export default component.exports